module.exports = __webpack_public_path__ + "static/media/user.b3f65ec5.png";